import { render, staticRenderFns } from "./jhi-sort-indicator.vue?vue&type=template&id=2a8bfca0"
import script from "./jhi-sort-indicator.component.ts?vue&type=script&lang=ts&external"
export * from "./jhi-sort-indicator.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports